/** Ce qu'une route déclare d'elle-même, lu par `RouteAnnouncer`. */
export type RouteHandle = {
  /** Clé i18n du nom de l'écran, pour le titre de la page (RGAA 8.6). */
  title?: string
}

/** Titre d'onglet : l'écran d'abord (ce qui change d'une page à l'autre), puis l'organisation. */
export function pageTitle(screen: string | undefined, appName: string): string {
  return screen ? `${screen} – ${appName}` : appName
}

/**
 * Clé du titre d'écran pour ce rôle. `/users` fait exception : le formateur n'y
 * voit que ses apprenants, et la barre de navigation le lui annonce ainsi — le
 * titre de l'écran et celui de l'onglet doivent le nommer pareil.
 */
export function screenTitleForRole(key: string | undefined, role: string | undefined): string | undefined {
  return key === 'common.routing.users' && role !== 'Admin' ? 'common.learners' : key
}

/** Le titre de l'écran le plus profond qui en déclare un. */
export function screenTitleKey(matches: { handle?: unknown }[]): string | undefined {
  for (let i = matches.length - 1; i >= 0; i--) {
    const title = (matches[i]?.handle as RouteHandle | undefined)?.title
    if (title) return title
  }
  return undefined
}
